import React, { Component } from 'react';
import { fetchOblacDrivesReleases, compareOblacDrivesReleasesByDateDesc, makeCdnUrl } from 'motion-master-client';
import { GlobalHotKeys } from 'react-hotkeys';

import './App.css';
import DevelopmentReleases from './DevelopmentReleases';
import FirmwareBundles from './FirmwareBundles';
import FirmwarePackages from './FirmwarePackages';
import Nav from './Nav';
import ProductionReleases from './ProductionReleases';
import { brandId } from './brand';
import Icon from "./icons";

class App extends Component {
  // With only one key map and handlers array one of the key maping failed to work.
  // Had to use two of key maps, handlers, and <GlobalHotKeys> elements to overcome this problem.

  keyMap1 = {
    PETR_MODE_1: ["ctrl+,"],
  };

  keyMapHandlers1 = {
    PETR_MODE_1: () => this.toggleExpertMode(),
  };

  keyMap2 = {
    PETR_MODE_2: ["ctrl+`"],
  };

  keyMapHandlers2 = {
    PETR_MODE_2: () => this.toggleExpertMode(),
  };

  odusVersion = "3.0.6";
  // Keeping the old URL for now since it's outside the oblac-drives path in the Synapticon bucket and isn't exposed via CDN.
  odusBundleHref = `https://s3.amazonaws.com/synapticon/oblac-drives-update-service/bundles/oblac-drives-update-service_v${this.odusVersion}.odbx`;
  odusBundleTitle = `Download OBLAC Drives Update Service v${this.odusVersion} bundle`;

  constructor(props) {
    super(props);

    const petrMode = sessionStorage.getItem("petrMode") === "true";

    this.state = {
      developmentReleases: null,
      petrMode,
      productionReleases: null,
      showFirmwareBundlesAndPackages: false,
    };
  }

  async componentDidMount() {
    // Fetch production and development releases.
    fetchOblacDrivesReleases(false)
      .then((releases) => {
        if (!releases.every(Boolean)) {
          throw new Error("Failed to fetch releases.");
        }
        this.updateReleasesState(releases);
        this.checkIfElectronSetupFilesExist(releases);
      })
      .catch((err) => {
        alert(err.message);
      });
  }

  updateReleasesState(releases) {
    const [productionReleases, developmentReleases] = releases;
    if (productionReleases && developmentReleases) {
      productionReleases.sort(compareOblacDrivesReleasesByDateDesc);
      developmentReleases.sort(compareOblacDrivesReleasesByDateDesc);
      this.setState({ productionReleases, developmentReleases });
    }
  }

  async checkIfElectronSetupFilesExist(releases) {
    const [productionReleases, developmentReleases] = releases;
    if (productionReleases && developmentReleases) {
      const productionResults = await Promise.all(
        productionReleases.map(async (r) => await this.addSetupUrlsToRelease(r))
      );

      const developmentResults = await Promise.all(
        developmentReleases.map(
          async (r) => await this.addSetupUrlsToRelease(r)
        )
      );

      this.setState({
        productionReleases: productionResults,
        developmentReleases: developmentResults,
      });
    }
  }

  async addSetupUrlsToRelease(release) {
    const bundleFileUrl =  makeCdnUrl(`/brands/${brandId}/bundles/releases/oblac-drives_${release.version}.odbx`);
    const windowsAppUrl = makeCdnUrl(`/brands/${brandId}/releases/OBLAC-Drives_${release.version}_Setup.exe`);
    const linuxAppUrl = makeCdnUrl(`/brands/${brandId}/releases/oblac-drives_${release.version}_amd64.deb`);

    // const [bundleFileResponse, windowsResponse, linuxResponse] = await Promise.all([
    //   fetch(bundleFileUrl, { method: 'HEAD' }),
    //   fetch(windowsAppUrl, { method: 'HEAD' }),
    //   fetch(linuxAppUrl, { method: 'HEAD' }),
    // ]);

    // if (bundleFileResponse.ok) {
    //   release.hasBundleFile = true;
    release.bundleFileUrl = bundleFileUrl;
    // }

    // if (windowsResponse.ok) {
    //   release.hasWindowsApp = true;
    release.windowsAppUrl = windowsAppUrl;
    // }

    // if (linuxResponse.ok) {
    // release.hasLinuxApp = true;
    release.linuxAppUrl = linuxAppUrl;
    // }

    return release;
  }

  /**
   * Toggle expert (Petr) mode.
   */
  toggleExpertMode() {
    this.setState({ petrMode: !this.state.petrMode }, () => {
      sessionStorage.setItem("petrMode", this.state.petrMode);
    });
  }

  render() {
    const petrModeOnClassName = this.state.petrMode
      ? "expert-mode shadow-sm text-light enabled"
      : "expert-mode text-light shadow-sm";

    return (
      <div className="App">
        <GlobalHotKeys keyMap={this.keyMap1} handlers={this.keyMapHandlers1} />
        <GlobalHotKeys keyMap={this.keyMap2} handlers={this.keyMapHandlers2} />

        <Nav />

        <div className={petrModeOnClassName}>EXPERT MODE</div>

        <div
          className="modal"
          id="whatAreOblacBundlesModal"
          tabIndex="-1"
          role="dialog"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
              <div className="modal-header bg-primary text-light">
                <h4 className="modal-title font-weight-light">
                  What are OBLAC Bundles?
                </h4>
                <button
                  type="button"
                  aria-label="Close"
                  className="btn btn-outline-secondary text-light ml-2"
                  data-dismiss="modal"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <p>
                  OBLAC Bundles are files that can be used for installing newer
                  releases of{" "}
                  <a
                    href="https://doc.synapticon.com.cn/oblac_drives/index.html#oblac-drives"
                    target="_blank"
                    rel="noreferrer"
                  >
                    OBLAC Drives
                  </a>{" "}
                  or firmware versions in case the{" "}
                  <a
                    href="https://doc.synapticon.com.cn/oblac_drives/oblac_drives_setup/oblac_box_setup/index.html"
                    target="_blank"
                    rel="noreferrer"
                  >
                    OBLAC Drives Box
                  </a>{" "}
                  does not have an Internet connection.
                </p>
                <p>There are two types of OBLAC Bundles:</p>
                <h5>1. Release bundle</h5>
                <p>
                  This bundle includes an OBLAC Drives release, e.g.{" "}
                  <code>v21.0.0</code> and optionally all of its supported
                  firmwares. Install it using the Bundle Install feature in
                  OBLAC Drives Update Service. Once installed, the selected
                  release will run, if the bundle includes the firmwares, then
                  all of its supported firmwares will be available in the OBLAC
                  Drives Install Firmware dialog.
                </p>
                <img
                  src="/images/offline-zone.png"
                  alt="Offline Zone"
                  className="img-fluid shadow-sm border"
                ></img>
                <h5 className="mt-4">2. Firmware bundle</h5>
                <p>
                  This bundle includes files for all hardware variants of a
                  single firmware version, e.g. <code>v4.4.3</code>. Install it
                  using the OBLAC Drives Install Firmware dialog onto one or
                  more devices.
                </p>
                <img
                  src="/images/install-firmware.png"
                  alt="Install Firmware"
                  className="img-fluid shadow-sm border"
                ></img>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="row">
            <div className="col">
              <div
                className="alert alert-info bg-white shadow-sm p-3"
                role="alert"
              >
                <h5 className="alert-heading">
                  OBLAC Drives Update Service Bundle
                </h5>
                <div className="mb-2">
                  To utilize the latest features of OBLAC Drives, which include
                  support for offline usage, please install the most recent
                  version of the OBLAC Drives Update Service using the Bundle
                  Install feature.
                </div>
                <a
                  href={this.odusBundleHref}
                  className="btn btn-md btn-primary rounded font-weight-bold"
                  title={this.odusBundleTitle}
                >
                  <div className="download-wrapper">
                    {Icon.download}&nbsp;v{this.odusVersion}
                  </div>
                </a>
              </div>
              <div
                className="alert alert-info bg-white shadow-sm"
                role="alert"
                style={{ padding: "1rem" }}
              >
                <h5 className="alert-heading">Firmware Release Labels</h5>
                <div>
                  You may encounter firmware labeled as <code>alpha</code>,{" "}
                  <code>beta</code>, or <code>rc</code>. These labels are
                  designed to help you assess the maturity of the build.
                  <ul>
                    <li>
                      <strong>Alpha</strong> - This build includes some new
                      features and is provided exclusively to customers for
                      testing as part of the development process. The general
                      public does not have access to these builds.
                    </li>
                    <li>
                      <strong>Beta</strong> - The full feature set is complete,
                      but there are known issues that still need to be
                      addressed. We release it for select application testing,
                      especially for applications where the new feature is
                      critical.
                    </li>
                    <li>
                      <strong>RC (Release Candidate)</strong> - At this stage,
                      the build is released to the public for evaluation. The
                      maturity of the feature set is high, and we are actively
                      seeking issues that may arise in special use cases.
                    </li>
                  </ul>
                  If you suspect there is a problem with the firmware, please
                  submit a bug report to{" "}
                  <a href="mailto:support@synapticon.com?Subject=Report%20firmware%20bug">
                    support@synapticon.com
                  </a>
                  !
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col">
              <ProductionReleases
                releases={this.state.productionReleases}
                petrMode={this.state.petrMode}
              />
            </div>
          </div>

          {this.state.petrMode && (
            <div className="row mt-4">
              <div className="col">
                <h3>Development Releases</h3>
                <DevelopmentReleases
                  releases={this.state.developmentReleases}
                  runningRelease={this.state.runningRelease}
                  runButtonsDisabled={this.runButtonsDisabled}
                  pulledImages={this.state.pulledImages}
                  appOnline={this.state.appOnline}
                  boxOnline={this.state.boxOnline}
                  offline={this.offline}
                  petrMode={this.state.petrMode}
                  fetchingBundleFile={this.state.fetchingBundleFile}
                  installingBundle={this.state.installingBundle}
                  onRunRelease={this.handleRunRelease}
                  onInstallOblacDrivesUpdateService={
                    this.handleInstallOblacDrivesUpdateService
                  }
                  onInstallOblacDrivesProxyCache={
                    this.handleInstallOblacDrivesProxyCache
                  }
                />
              </div>
            </div>
          )}

          {this.state.petrMode && this.state.showFirmwareBundlesAndPackages && (
            <div className="row mt-4">
              <div className="col-md-5">
                <h3>Firmware Bundles</h3>
                <hr className="mt-0" />
                <FirmwareBundles />
              </div>
              <div className="col-md-7">
                <h3>Firmware Packages</h3>
                <hr className="mt-0" />
                <FirmwarePackages />
              </div>
            </div>
          )}

          <hr></hr>

          <div className="row mt-3">
            <div className="col mb-4 text-center">
              © 2010-{new Date().getFullYear()} Synapticon GmbH – Integrated
              Motion.
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default App;
